import React from 'react';

const TabButton = ({ isActive, onClick, icon: Icon, children }) => (
  <button
    onClick={onClick}
    className={`
      flex-1 px-4 py-4 text-sm font-medium relative transition-all duration-300 ease-in-out
      ${isActive 
        ? 'text-[#202654] bg-white' 
        : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
      }
    `}
  >
    <div className="flex items-center justify-center space-x-2">
      <Icon className={`h-5 w-5 transition-colors duration-300 ${isActive ? 'text-[#202654]' : 'text-gray-400'}`} />
      <span>{children}</span>
    </div>
    {isActive && (
      <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#202654] transform scale-x-100 transition-transform duration-300" />
    )}
  </button>
);

export default TabButton; 